<div class="confirm-dialog">
  <div class="confirm-dialog__header">
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <button matIconButton mat-dialog-close aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <p>{{ data.message }}</p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button matButton mat-dialog-close>{{ data.cancelText }}</button>
    @if (data.thirdButtonText) {
      <button matButton="elevated" [color]="data.thirdButtonColor || 'primary'" (click)="onThirdButton()">
        {{ data.thirdButtonText }}
      </button>
    }
    <button matButton="elevated" [color]="data.confirmColor" (click)="onConfirm()">
      {{ data.confirmText }}
    </button>
  </mat-dialog-actions>
</div>
